/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_SupportInputs */

const en_nav_support = /** @type {(inputs: Nav_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support Us`)
};

const id_nav_support = /** @type {(inputs: Nav_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dukung Kami`)
};

/** @type {(inputs: Nav_SupportInputs) => LocalizedString} */
const es_nav_support = en_nav_support;

/** @type {(inputs: Nav_SupportInputs) => LocalizedString} */
const fr_nav_support = en_nav_support;

/** @type {(inputs: Nav_SupportInputs) => LocalizedString} */
const de_nav_support = en_nav_support;

/** @type {(inputs: Nav_SupportInputs) => LocalizedString} */
const ja_nav_support = en_nav_support;

/** @type {(inputs: Nav_SupportInputs) => LocalizedString} */
const zh_nav_support = en_nav_support;

/** @type {(inputs: Nav_SupportInputs) => LocalizedString} */
const ar_nav_support = en_nav_support;

/** @type {(inputs: Nav_SupportInputs) => LocalizedString} */
const it_nav_support = en_nav_support;

/** @type {(inputs: Nav_SupportInputs) => LocalizedString} */
const ru_nav_support = en_nav_support;

/** @type {(inputs: Nav_SupportInputs) => LocalizedString} */
const pt_nav_support = en_nav_support;

/** @type {(inputs: Nav_SupportInputs) => LocalizedString} */
const ko_nav_support = en_nav_support;

/**
* | output |
* | --- |
* | "Support Us" |
*
* @param {Nav_SupportInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_support = /** @type {((inputs?: Nav_SupportInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_SupportInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_support(inputs)
	if (locale === "es") return es_nav_support(inputs)
	if (locale === "fr") return fr_nav_support(inputs)
	if (locale === "de") return de_nav_support(inputs)
	if (locale === "ja") return ja_nav_support(inputs)
	if (locale === "zh") return zh_nav_support(inputs)
	if (locale === "ar") return ar_nav_support(inputs)
	if (locale === "id") return id_nav_support(inputs)
	if (locale === "it") return it_nav_support(inputs)
	if (locale === "ru") return ru_nav_support(inputs)
	if (locale === "pt") return pt_nav_support(inputs)
	return ko_nav_support(inputs)
});